import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';
import ICON_CS from '@/assets/sideBar/CS.png';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

function ContactModal({ isOpen, onClose }: Props) {
  return (
    <>
      <Modal isOpen={isOpen}>
        <ContactList>
          <ContactItem>
            <ContactIcon style={{ backgroundColor: '#7CA7FA' }}>
              <img src={ICON_CS} alt='' width={18} />
            </ContactIcon>
            <Contact>02-6275-8011</Contact>
          </ContactItem>
        </ContactList>
        <CloseButton onClick={onClose}>
          <Icon.X size={16} fillColor='#fff' />
        </CloseButton>
      </Modal>
      {isOpen && <Backdrop onClick={onClose} />}
    </>
  );
}

const Modal = styled.aside<{ isOpen: boolean }>`
  background-color: #fff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  z-index: 700;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  transition: all 200ms ease-in-out;
  transform: ${({ isOpen }) =>
    isOpen ? 'translateY(0%)' : 'translateY(-100%)'};
`;

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background-color: #cbccce;
  border-radius: 100px;
  flex-shrink: 0;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 650;
`;

const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 262px;
  margin-top: 10px;
`;

const ContactItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background-color: #f5f6f7;
  border-radius: 100px;
  height: 44px;
  padding: 0 14px 0 5px;
  width: 100%;
`;

const ContactIcon = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  flex-shrink: 0;
`;

const Contact = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 212px;
  color: #3a3b3e;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
`;

export default ContactModal;
